<template>

  <div class="q-container" :class="{ selected: is_focused }" @mousedown="focusCard">

    <!-- Question Index, Emoji Icon and Text -->
    <div class="main-row">
      <p class="question-index">{{ index + 1 }}.</p>
      <div class="question-emoji-container">
        <button @click="is_new_question_dropdown_visible=true;show_advanced_dropdown=false;show_media_dropdown=false">{{ getAnswerTypeEmoji(block.answer_type) }}</button>
        <NewQuestionDropdown
        v-if="is_new_question_dropdown_visible"
        class="new-question-dropdown"
        :should_change_answer_type="true"
        :insert_at_index="index"
        v-on-clickaway="hideNewQuestionDropdown"
        v-on:hide="hideNewQuestionDropdown" />
      </div>
      <a-tooltip title="Please enter some text for this" :visible="show_errors && block.text === ''">
        <a-textarea
        :value="block.text"
        @input="updateQuestionText($event)"
        @focus="focusCard"
        :placeholder="getPlaceholderText(block.answer_type)"
        :autoSize="true"
        />
      </a-tooltip>
    </div>


    <!-- NPS Score -->
    <div class="nps-container" v-if="block.answer_type === 'nps'">
      <p>0 is not at all likely, 10 is extremely likely</p>
    </div>

    <!-- Media Preview -->
    <div class="media-row" v-if="block.media && block.media.length > 0">
      <div class="media-container" v-for="(media, media_index) in block.media" :key="media_index">
        <div class="media-container-overlay" :class="{ darken: media.is_uploading }">
          <a-spin v-if="media.is_uploading" class="uploading-spinner"><a-icon slot="indicator" type="loading" style="font-size: 40px; color: white;" spin /></a-spin>
          <button v-if="!media.is_uploading" class="media-preview-btn" @click="showMediaPreview(media)" />
          <button class="media-delete-btn" @click="removeMedia(media_index)" />
        </div>
        <img   v-if="media.type === 'image'" :src="media.url" />
        <video v-if="media.type === 'video'" :src="media.url" preload="metadata" height="115" ></video>
        <div   v-if="media.type === 'audio'" class="audio-preview"></div>
      </div>
      <label v-if="is_focused" class="media-btn-round">
        <input @change="addMedia($event)" type="file" ref="file" accept="image/png, image/jpeg, video/mp4, audio/mpeg, audio/mp4, audio/ogg, audio/acc" />
      </label>
    </div>


    <!-- List of all multi-choice options -->
    <div class="option-container" v-if="block.answer_type === 'multi_choice'">

      <div v-for="(option, option_index) in block.multi_choice" :key="option_index" class="option-row">
        <div class="option-text">
          <div class="option-icon"></div>
          <a-tooltip title="Please enter some text for this" :visible="show_errors && option.text === ''">
            <a-input
            :value="option.text"
            @input="updateOptionText($event, option_index)"
            placeholder="Option"
            type="text" />
          </a-tooltip>
          <div @click="removeOption(option_index)" v-if="is_focused && block.multi_choice.length >= 3" class="close-icon"></div>
        </div>
        <div class="go-to" v-if="is_focused && show_go_to">
          <p>Go To</p>
          <a-select @change="selectOptionGoTo($event, option_index)" :value="option.go_to" default-value="none">
            <a-select-option
            v-for="go_to_option of go_to_options_mc"
            :value="go_to_option.value" :key="go_to_option.value">{{ go_to_option.text }}</a-select-option>
          </a-select>
        </div>
      </div>
      <button @click="addOption" v-if="is_focused" class="add-option-btn">Add Option</button>
    </div>


    <!-- Go-To Row (Non-Multiple Choice) -->
    <div v-if="is_focused && show_go_to && block.answer_type !== 'multi_choice'" class="go-to-row">
      <p>Go To</p>
      <a-select @change="selectGoTo" :value="block.answer_options.go_to" default-value="none">
        <a-select-option
        v-for="go_to_option of go_to_options"
        :value="go_to_option.value" :key="go_to_option.value">{{ go_to_option.text }}</a-select-option>
      </a-select>
    </div>


    <!-- Buttons (toggle advanced, duplicate and delete)  -->
    <div v-if="is_focused" class="selected-row">

      <a-tooltip placement="top" title="Add Media">
        <a-button @click="show_media_dropdown = !show_media_dropdown; show_advanced_dropdown = false" class="media-btn footer-btn" :class="{ selected: show_media_dropdown }"></a-button>
      </a-tooltip>

      <a-tooltip placement="top" title="Go-To Logic">
        <a-button @click="show_go_to = !show_go_to" class="go-to-btn footer-btn" :class="{ selected: show_go_to }"></a-button>
      </a-tooltip>

      <a-tooltip placement="top" title="Advanced Options" v-if="block.answer_type !== 'say'">
        <a-button @click="show_advanced_dropdown = !show_advanced_dropdown; show_media_dropdown = false" class="advanced-btn footer-btn" :class="{ selected: show_advanced_dropdown }"/></a-button>
        <!-- <a-button @click="show_advanced_dropdown = !show_advanced_dropdown; show_media_dropdown = false" class="advanced-btn footer-btn" :class="{ selected: show_advanced_dropdown, advanced_btn_1: (advanced_option_selected_count === 1), advanced_btn_2: (advanced_option_selected_count === 2),advanced_btn_3: (advanced_option_selected_count === 3) }"/></a-button> -->
      </a-tooltip>

      <a-tooltip placement="top" title="Duplicate">
        <a-button @click="duplicateQuestion" class="duplicate-btn footer-btn"/></a-button>
      </a-tooltip>

      <a-tooltip placement="top" title="Delete">
        <a-button @click="deleteQuestion" class="delete-btn footer-btn"/></a-button>
      </a-tooltip>

      <div class="media-upload-dropdown dropdown-menu" v-if="show_media_dropdown">
        <p>Add Media</p>
        <div class="row" @click="$refs.imageInput.click()">
          <p class="image">Image</p>
          <p>.jpg or .png</p>
        </div>
        <div class="row" @click="$refs.videoInput.click()">
          <p class="video">Video</p>
          <p>.mp4; <16mb</p>
        </div>
        <div class="row" @click="$refs.audioInput.click()">
          <p class="audio">Audio</p>
          <p>.mp3, .mp4, .ogg, .acc</p>
        </div>
        <input @change="addMedia($event)" type="file" ref="imageInput" accept="image/png, image/jpeg"/>
        <input @change="addMedia($event)" type="file" ref="videoInput" accept="video/mp4"/>
        <input @change="addMedia($event)" type="file" ref="audioInput" accept="audio/mpeg, audio/mp4, audio/ogg, audio/acc"/>
      </div>

      <div class="advanced-options-dropdown dropdown-menu" v-if="show_advanced_dropdown && block.answer_type !== 'say'">
        <p>Advanced Options</p>
        <div class="row" >
          <p class="required">Required</p>
          <a-switch :checked="block.answer_options.is_required" @change="toggleRequired" size="small" />
        </div>
        <div class="row" v-if="block.answer_type === 'multi_choice'">
          <p class="multi-select">Multi-Select</p>
          <a-switch :checked="block.answer_options.is_multiselect" @change="toggleMultiselect" size="small" />
        </div>
        <div class="row" v-if="!['multi_choice', 'location', 'nps'].includes(block.answer_type)">
          <p class="multiple-answers">Multiple Answers</p>
          <a-switch :checked="block.answer_options.is_multipart" @change="toggleMultipart" size="small" />
        </div>
        <div class="row image-intelligence" v-if="block.answer_type === 'image'">
          <div>
            <p class="image-intelligence">Image Intelligence</p>
            <p>OCR and Logo Detection</p>
          </div>
          <a-switch :checked="block.answer_options.is_image_intelligence" @change="toggleImageIntelligence" size="small" />
        </div>
      </div>


    </div>

    <a-modal v-model="is_media_preview_visible" @ok="hideMediaPreview" @cancel="hideMediaPreview">
      <template v-if="media_preview">
        <img   v-if="media_preview.type === 'image'" :src="media_preview.url" class="media-preview"/>
        <video v-if="media_preview.type === 'video'" :src="media_preview.url" controls class="media-preview"/>
        <audio v-if="media_preview.type === 'audio'" controls class="media-preview" :src="media_preview.url"></audio>
      </template>
    </a-modal>

    <div v-if="is_focused && !is_last_question" class="inbetween-new-question-button-container">
      <button @click="is_inbetween_new_question_dropdown_visible=true"></button>
      <NewQuestionDropdown
      v-if="is_inbetween_new_question_dropdown_visible"
      v-on-clickaway="hideInbetweenNewQuestionDropdown"
      v-on:hide="hideInbetweenNewQuestionDropdown"
      v-on:focusCard="focusCardInbetween"
      :insert_at_index="index"
      class="inbetween-new-question-dropdown"
      />
    </div>

  </div>

</template>

<script>

import { db_helper } from '../../store/db_helper.js';
import { mixin as clickaway } from 'vue-clickaway';
import Compressor from 'compressorjs';
import NewQuestionDropdown from '@/components/new_survey/NewQuestionDropdown.vue';

export default {

  name: 'QuestionBlock',
  mixins: [ clickaway ],

  props: {
    index: Number,
    block: Object,
    is_focused: Boolean,
    show_errors: Boolean
  },

  data: function () {
    return {
      show_media_dropdown: false,
      show_advanced_dropdown: false,
      show_go_to: false,
      is_new_question_dropdown_visible: false,
      is_inbetween_new_question_dropdown_visible: false,
      is_media_preview_visible: false,
      media_preview: null
    }
  },

  computed: {

    go_to_options() {

      let go_to_arr = [];
      go_to_arr.push({ value: 'none', text: 'Next Question' });

      let subsequent_questions = this.$store.state.new_survey.questions.slice(this.index + 2); // starting question after next
      _.forEach(subsequent_questions, (question, question_index) => {
        question_index = this.index + question_index + 2;
        go_to_arr.push({
          value: question_index,
          text: `${this.getAnswerTypeEmoji(question.answer_type)} ${question_index + 1}. ${question.text}`
        });
      });
      let last_question_index = subsequent_questions.length + this.index + 2;
      go_to_arr.push({ value: last_question_index, text: 'End of Survey 👋' });
      return go_to_arr;
    },


    go_to_options_mc() {

      let go_to_arr = [];

      let all_questions = this.$store.state.new_survey.questions; // include all questions
      _.forEach(all_questions, (question, question_index) => {
        go_to_arr.push({
          value: question_index === this.index + 1 ? 'none' : question_index,
          text: question_index === this.index + 1 ? 'Next Question' : `${this.getAnswerTypeEmoji(question.answer_type)} ${question_index + 1}. ${question.text}`
        });
      });
      let last_question_index = all_questions.length + 1;
      go_to_arr.push({ value: last_question_index, text: 'End of Survey 👋' });

      // Filter out current question
      go_to_arr = _.filter(go_to_arr, entry => entry.value !== this.index);
      return go_to_arr;

    },

    is_last_question() {
      return (this.index + 1) === this.$store.state.new_survey.questions.length;
    },

    advanced_option_selected_count() {
      let count = 0;
      _.forEach(this.block.answer_options, (option, key) => {
        if (option === true) {
          count++;
        };
      });
      return count;
    }

  },

  components: {
    NewQuestionDropdown
  },

  methods: {

    getAnswerTypeEmoji(answer_type) {
      if (answer_type === 'video') {
        return '🎬';
      } else if (answer_type === 'multi_choice') {
        return '📊';
      } else if (answer_type === 'image') {
        return '📷';
      } else if (answer_type === 'audio') {
        return '🎙️';
      } else if (answer_type === 'text') {
        return '✏️';
      } else if (answer_type === 'location') {
        return '📍';
      } else if (answer_type === 'nps') {
        return '⚖️';
      } else if (answer_type === 'multimedia') {
        return '▶️';
      } else if (answer_type === 'say') {
        return '💬';
      } else if (answer_type === 'end_of_survey') {
        return '👋';
      };
    },

    updateQuestionText(event) {
      this.$store.commit('updateQuestionText', { text: event.target.value, question_index: this.index });
    },

    // Multi-Choice Option Methods
    addOption(option_index) {
      this.$store.commit('addOption', { question_index: this.index });
      this.$forceUpdate();
    },
    removeOption(option_index) {
      this.$store.commit('removeOption', { question_index: this.index, option_index });
      this.$forceUpdate();
    },
    updateOptionText(event, option_index) {
      this.$store.commit('updateOptionText', { text: event.target.value, question_index: this.index, option_index });
      this.$forceUpdate();
    },


    hideNewQuestionDropdown() {
      this.is_new_question_dropdown_visible = false;
    },

    hideInbetweenNewQuestionDropdown() {
      this.is_inbetween_new_question_dropdown_visible = false;
    },

    showMediaPreview(media) {
      this.is_media_preview_visible = true;
      this.media_preview = media;
    },

    hideMediaPreview() {
      this.is_media_preview_visible = false;
      this.media_preview = null;
    },

    addMedia(event) {
      let file = event.target.files[0];
      if (file && file.type) {
        if (file.type.includes('image')) {
          this.addImage(event);
        } else if (file.type.includes('video')) {
          this.addVideoOrAudio(event, 'video');
        } else if (file.type.includes('audio')) {
          this.addVideoOrAudio(event, 'audio');
        };
      };
      this.show_media_dropdown = false;
    },

    removeMedia(media_index) {
      this.$store.commit('removeQuestionMedia', { question_index: this.index, media_index });
    },

    addImage(event) {

      analytics.track('New Survey Question Image Uploaded');

      // Load the image preview immediately
      let file = event.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        let local_path = e.target.result;
        this.$store.commit('addQuestionMedia', { question_index: this.index, url: local_path, type: 'image' });
      };
      reader.readAsDataURL(file);

      let that = this;

      //Compress and upload the file to GCS
      new Compressor(file, {
        quality: 0.7,
        convertSize: 500000, // Convert PNG's over 0.5mb to JPG's
        success(result) {
          let random_id = db_helper.getRandomID();
          let media_ref = that.$storage.child(random_id);
          media_ref.put(result).then((snapshot) => {
            let media_url = `https://storage.googleapis.com/outside-voice-a1d45.appspot.com/${random_id}`;
            that.$store.commit('setQuestionMedia', { question_index: that.index, url: media_url });
          });
        },
        error(err) {
          console.log(err.message);
          let random_id = db_helper.getRandomID();
          let media_ref = that.$storage.child(random_id);
          media_ref.put(file).then((snapshot) => {
            let media_url = `https://storage.googleapis.com/outside-voice-a1d45.appspot.com/${random_id}`;
            that.$store.commit('setQuestionMedia', { question_index: this.index, url: media_url });
          });
        }
      });

    },

    addVideoOrAudio(event, type) {

      analytics.track(`New Survey ${_.capitalize(type)} Video Uploaded`);

      let file = event.target.files[0];

      if (file.size > 16777216) { // 16mb
        this.$message.error(`Please upload a file less than 16mb`, 3);
        return;
      };

      // Load the video preview immediately
      var reader = new FileReader();
      reader.onload = (e) => {
        let local_path = e.target.result;
        this.$store.commit('addQuestionMedia', { question_index: this.index, url: local_path, type });
      };
      reader.readAsDataURL(file);

      // Upload the video to Firebase and save the randomly generated public url
      let random_id = db_helper.getRandomID();
      let media_ref = this.$storage.child(random_id);
      media_ref.put(file).then((snapshot) => {
        console.log('video uploaded');
        let media_url = `https://storage.googleapis.com/outside-voice-a1d45.appspot.com/${random_id}`;
        this.$store.commit('setQuestionMedia', { question_index: this.index, url: media_url });
      });
    },

    toggleRequired() {
      this.$store.commit('toggleRequired', { index: this.index });
      this.$forceUpdate();
    },
    toggleMultipart() {
      this.$store.commit('toggleMultipart', { index: this.index });
      this.$forceUpdate();
    },
    toggleMultiselect() {
      this.$store.commit('toggleMultiselect', { index: this.index });
      this.$forceUpdate();
    },
    toggleImageIntelligence() {
      this.$store.commit('toggleImageIntelligence', { index: this.index });
      this.$forceUpdate();
    },

    duplicateQuestion() {
      this.$store.commit('duplicateQuestionBlock', { index: this.index });
      this.$emit('focusCard', ( this.index + 1 ));
    },

    deleteQuestion() {
      this.$store.commit('deleteQuestionBlock', { index: this.index });
    },

    selectGoTo(go_to_index) {
      this.$store.commit('updateQuestionGoTo', { question_index: this.index, go_to_index });
      this.$forceUpdate();
    },
    selectOptionGoTo(go_to_index, option_index) {
      this.$store.commit('updateOptionGoTo', { question_index: this.index, option_index, go_to_index });
      this.$forceUpdate();
    },

    focusCard(e) {
      if (!this.is_focused) {
        this.show_media_dropdown = false;
        this.show_advanced_dropdown = false;
      };
      this.$emit('focusCard', this.index);
    },

    focusCardInbetween(index) {
      this.$emit('focusCard', index);
    },

    update(){
      this.$mount();
    },

    getPlaceholderText(answer_type) {
      switch (answer_type) {
        case 'text':
          return "What's your name?";
        case 'audio':
          return 'How was the weather today?';
        case 'image':
          return 'Could you take a photo of your living room?';
        case 'video':
          return 'Could you show us around your kitchen?';
        case 'multi_choice':
          return 'Which of these options do you prefer?';
        case 'location':
          return 'Could you share your location?';
        case 'nps':
          return 'How likely would you be to recommend us to a friend?';
        case 'say':
          return 'Say something to respondents';
        default:
          return 'Write your question here';
      };
    }

  }

}
</script>

<style scoped lang="scss">



.q-container{
  padding: 15px;
  margin-bottom: 25px;
  background-color: white;
  border: 1px solid rgb(220,220,220);
  border-radius: 6px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  position: relative;

  &.selected{
    border-color: #3F96FB;
  }




  .main-row{
    display: flex;
    font-family: "Montserrat";

    .question-index{
      font-size: 18px;
      font-weight: 600;
      margin-left: 5px;
      margin-right: 12px;
      margin-bottom: 0px;
      transform: translateY(7px);
      cursor: move;
    }
    .question-emoji-container{
      position: relative;
      button{
        color: black;
        font-size: 22px;
        padding: 3px 7px 3px 8px;
        margin-right: 10px;
        background-color: transparent;
        border: 1px solid rgb(230,230,230);
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.2s ease;
        &:hover{
          background-color: rgb(245,245,245);
        }
        &:focus{
          outline: none;
        }
      }
      .new-question-dropdown{
        position: absolute;
          top: 50px;
          left: 10px;
          z-index: 3;
        margin-bottom: 40px;
      }
    }
    textarea{
      font-size: 15px;
      font-weight: 500;
      padding: 8px 11px 9px 11px;
    }
  }


  // Message explaining NPS question type
  .nps-container{
    display: inline-block;
    padding: 9px 14px 10px 14px;
    background-color: rgb(240,240,240);
    margin-left: 76px;
    margin-top: 14px;
    border-radius: 4px;
    p{
      margin: 0;
    }
  }

  .media-row{
    background-color: rgb(246,246,246);
    border-radius: 4px;
    height: 130px;
    padding: 10px;
    padding-right: 100px;
    margin-top: 15px;
    margin-left: 92px;
    display: flex;
    align-items: center;
    overflow-x: scroll;

    .media-container{
      height: 90%;
      min-width: 100px;
      background-color: white;
      margin-right: 10px;
      position: relative;
      overflow: hidden;
      border-radius: 4px;
      img, video{
        display: flex;
        align-self: center;
        height: 100%;
        margin: 0 auto;
        border-radius: 4px;
      }
      .audio-preview{
        height: 100%;
        width: 100%;
        background-size: 60px;
        background-image: url("../../assets/icons/audio-preview.svg");
        background-position: center center;
        background-repeat: no-repeat;
      }
      .media-container-overlay{
        position: absolute;
          top: 0;
          left: 0;
        height: 100%;
        width: 100%;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
        button{
          margin-left: 6px;
          margin-right: 6px;
          background-repeat: no-repeat;
          background-color: transparent;
          background-position: center;
          border: none;
          transition: all 0.2s ease;
          opacity: 0;
          cursor: pointer;
          &:hover{
            opacity: 1 !important;
          }
          &:focus{
            outline: none;
          }
        }
        .media-preview-btn{
          height: 22px;
          width: 30px;
          background-size: 22px;
          background-image: url("../../assets/icons/media-preview-btn.svg");
        }
        .media-delete-btn{
          height: 20px;
          width: 20px;
          background-size: 20px;
          background-image: url("../../assets/icons/media-delete-btn.svg");
        }
        &:hover{
          background-color: rgba(0,0,0,.3);
          .media-preview-btn,
          .media-delete-btn{
            opacity: .8;
          }
        }
        &.darken{
          background-color: rgba(0,0,0,.5);
        }
        .uploading-spinner{
          position: absolute;
            top: 27px;
            left: 50%;
            transform: translateX(-17px);
          cursor: pointer;
        }
      }
    }

    .media-btn-round{
      height: 35px;
      width: 35px;
      background-size: 35px;
      background-image: url("../../assets/icons/question-btn-media-round.svg");
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
      transition: all 0.2s ease;
      &:hover{
        transform: scale(1.05, 1.05);
      }
    }
  }


  // For Multi-Choice Options
  .option-container{
    padding-left: 92px;
    margin-top: 16px;

    .option-row{
      margin-bottom: 14px;

      .option-text{
        display: flex;
        align-items: center;

        .option-icon{
          height: 13px;
          width: 13px;
          margin-right: 10px;
          background-image: url("../../assets/icons/option-dot-icon.svg");
          background-size:contain;
          background-position: center;
          background-repeat: no-repeat;
        }
        .close-icon{
          height: 12px;
          width: 12px;
          margin-left: 15px;
          margin-right: 5px;
          background-image: url("../../assets/icons/close-btn.svg");
          background-size:contain;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .7;
          transition: all 0.2s ease;
          cursor: pointer;
          &:hover{
            opacity: 1;
          }
        }

      }

      .go-to{
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        margin-top: 18px;
        margin-left: 18px;
        margin-right: 31px;
        p{
          margin-right: 10px;
          margin-bottom: 0px;
          white-space: nowrap;
        }
        .ant-select{
          flex-grow: 1;
          max-width: 100%;
        }
      }

    }
    .add-option-btn{
      border: none;
      background-color: transparent;
      outline: none;
      margin-left: 13px;
      font-weight: 500;
      cursor: pointer;
    }
  }



  .selected-row{
    position: relative;
    display: flex;
    justify-content: flex-end;
    margin-top: 18px;
    margin-bottom: 7px;
    .footer-btn{
      height: 28px;
      width: 28px;
      margin-left: 10px;
      background-size: 20px;
      background-position: center;
      background-repeat: no-repeat;
      background-color: transparent;
      border: none;
      border-radius: 4px;
      opacity: .8;
      cursor: pointer;
      transition: opacity 0.2s ease;
      &:focus{
        outline: none;
      }
      &:hover{
        opacity: 1;
      }
    }

    .media-btn,
    .advanced-btn,
    .go-to-btn{
      background-position: 3px 4px;
      &:focus{
        outline: none;
      }
      &.selected{
        background-color: rgb(238,238,238);
      }
    }
    .media-btn{
      background-image: url("../../assets/icons/question-btn-media.svg");
    }
    .advanced-btn{
      background-image: url("../../assets/icons/question-btn-advanced.svg");
      background-size: 20px;
      &.advanced_btn_1,
      &.advanced_btn_2,
      &.advanced_btn_3{
        background-size: 23px;
      }
      &.advanced_btn_1{
        background-image: url("../../assets/icons/question-btn-advanced-1.svg");
      }
      &.advanced_btn_2{
        background-image: url("../../assets/icons/question-btn-advanced-2.svg");
      }
      &.advanced_btn_3{
        background-image: url("../../assets/icons/question-btn-advanced-3.svg");
      }
    }
    .go-to-btn{
      background-image: url("../../assets/icons/question-btn-go-to.svg");
    }
    .duplicate-btn{
      background-image: url("../../assets/icons/question-btn-duplicate.svg");
    }
    .delete-btn{
      background-image: url("../../assets/icons/question-btn-delete.svg");
    }
  }


  .dropdown-menu{
    position: absolute;
      top: 28px;
    width: 250px;
    padding: 18px 16px;
    padding-bottom: 12px;
    height: auto;
    background-color: white;
    border: 1px solid rgb(240,240,240);
    border-radius: 4px;
    box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.15);
    z-index: 3;
    font-family: "Montserrat";
    & > p{
      margin-bottom: 6px;
      font-size: 13px;
      font-weight: 600;
      opacity: .4;
    }
    .row{
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgb(235,235,235);
      &:last-of-type{
        border-bottom: none;
      }
      p{
        font-size: 13px;
        font-weight: 600;
        letter-spacing: -.25px;
        margin: 0;
        padding-left: 28px;
        background-position: center left;
        background-repeat: no-repeat;
        background-size: 18px;
      }
    }
  }


  .media-upload-dropdown{
    right: -60px;
    padding: 18px 0px;
    padding-bottom: 12px;
    & > p{
      margin-left: 16px;
    }
    .row{
      padding-left: 16px;
      padding-right: 16px;
      p{
        padding-left: 32px;
        background-size: 15px;
        &.image{
          background-image: url("../../assets/icons/media-upload-image.svg");
        }
        &.video{
          background-image: url("../../assets/icons/media-upload-video.svg");
        }
        &.audio{
          background-image: url("../../assets/icons/media-upload-audio.svg");
        }
        &:last-of-type{
          font-size: 10px;
          text-align: right;
        }
      }
      cursor: pointer;
      transition: background-color 0.2s ease;
      &:hover{
        background-color: rgb(245,245,245);
      }
    }
  }


  .advanced-options-dropdown{
    width: 235px;
    right: -125px;
    .row{
      p{
        &.required{
          background-image: url("../../assets/icons/answer-options-required.svg");
        }
        &.multiple-answers{
          background-image: url("../../assets/icons/answer-options-multiple-answers.svg");
        }
        &.multi-select{
          background-image: url("../../assets/icons/answer-options-multi-select.svg");
        }
        &.image-intelligence{
          background-image: url("../../assets/icons/answer-options-image-intelligence.svg");
        }
      }
      .ant-switch-checked{
        background: linear-gradient(135deg, #36dca7 1%,#19c6af 100%);
        border: 0.5px solid #20A379;
      }
      &.image-intelligence{
        height: 70px;
        p{
          font-size: 10px;
          font-weight: 500;
          &:first-of-type{
            font-size: 13px;
            font-weight: 600;
          }
        }
      }
    }
  }


  .go-to-row{
    padding-left: 35px;
    margin-top: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 23px;
    p{
      margin-right: 10px;
      margin-bottom: 0px;
      white-space: nowrap;
    }
    .ant-select{
      flex-grow: 1;
      max-width: 90%;
    }
  }

  .inbetween-new-question-button-container{
    position: absolute;
      top: 97%;
      left: -50px;
    z-index: 4;
    button{
      height: 44px;
      width: 44px;
      background-size: 44px;
      background-color: transparent;
      background-image: url("../../assets/icons/question-btn-media-round.svg");
      background-repeat: no-repeat;
      background-position: center;
      border: none;
      cursor: pointer;
      transition: all 0.2s ease;
      &:hover{
        transform: scale(1.05, 1.05);
      }
      &:focus{
        outline: none;
      }
    }
  }

}



img.media-preview{
  width: 100%;
}
video.media-preview{
  width: 100%;
  max-height: 500px;
}
audio.media-preview{
  width: 100%;
  margin-top: 20px;
}
input[type="file"] {
  display: none;
}
.ant-select-dropdown-menu-item{
  color: black !important;
}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

.q-container{
  .main-row{
    .question-index{
      font-size: 16px;
      margin-right: 8px;
      margin-left: 0px;
    }
  }
  .advanced-row{
    padding-left: 4px;
  }
  .option-container{
    padding-left: 51px;
  }
  .inbetween-new-question-button-container{
    top: 93%;
    left: -20px;
  }
}

}


</style>
